import axios from "axios";
import authHeader from "../../helpers/authHeader";
import getApiUrl from "../../helpers/apiUrls";
import * as commonActions from "../../store/common/actions";
import utilCommon from "../../helpers/utilCommon";
import {getShipmentDetail} from "../shipmentService";
import {getAddresses} from "../quoteService";
import * as type from "../../store/shipment/actionTypes";
import {setIsTransactionsInProcess} from "../../store/shipment/actions";
const lodash = require('lodash');

export const updateFcTlShipment = (dispatch, dictionary, lang, inputDTO) => {
    const url = getApiUrl('shipment', 'updateTLShipment');
    const waitingForExecution = lodash.get(inputDTO, 'waitingForExecution', false);
    dispatch(commonActions.setLoader(true));
    if (waitingForExecution) dispatch(setIsTransactionsInProcess(true));

    axios.put(url, inputDTO, {headers: authHeader()})
        .then((response) => {
            dispatch(commonActions.setLoader(false));
            if (waitingForExecution) dispatch(setIsTransactionsInProcess(false));

            if (response.data.success) {
                getShipmentDetail(dispatch, {shipmentUuid: inputDTO.shipmentId}).then((shipmentDetailResponse) => {
                    getAddresses(dispatch, lang, dictionary, {stopLoader: lodash.get(inputDTO, 'stopLoader', true)});
                    if (lodash.get(inputDTO, 'resetBolStatus', false)) {
                        dispatch({
                            type: type.SET_BOL_STATUS,
                            status: false,
                            shipmentUuid: inputDTO.shipmentId,
                            documentsGenerated: false
                        });
                    }

                    if (inputDTO.nextPage) {
                        const isBGShipment = !lodash.isEmpty(
                            lodash.get(shipmentDetailResponse, 'data.content.shipmentList.0.tlShipmentData.rateQuotes', [])
                        )

                        if (isBGShipment) {
                            Window['history'].push('/customer/tl-quote-results')
                        } else {
                            Window['history'].push('/customer/tl-shipment', {shipmentUuid: inputDTO.shipmentId})
                        }
                    }
                });

                utilCommon.showNotification('Saved successfully', dictionary, lang);
            } else {
                if (waitingForExecution) dispatch(setIsTransactionsInProcess(false));
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, lang, false, 'error')
                });
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false));
            utilCommon.showNotification('Something went wrong during updating shipment', dictionary, lang, false, 'error');
        });
}

export const saveRateQuote = (dispatch, dictionary, lang, inputDTO) => {
    const url = getApiUrl('shipment', 'saveTlRateQuote');

    axios.post(url, inputDTO, {headers: authHeader()})
        .then((response) => {
            if (response.data.success) {
                Window['history'].push('/customer/tl-shipment', {shipmentUuid: inputDTO.shipmentId})
                utilCommon.showNotification('Saved successfully', dictionary, lang)
            } else {
                utilCommon.showNotification('Internal server error', dictionary, lang, false, 'error')
            }
        });
}

export const deletePickupDropAddress = (dispatch, dictionary, lang, inputDTO) => {

}

export default {
    updateFcTlShipment,
    saveRateQuote,
    deletePickupDropAddress
}
